import { Player } from "components/Player/Player";
import { useDiscoContent } from "hooks/useDiscoContent";
import { observer } from "mobx-react";
import type React from "react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

export const ExtraPractisingPage: React.FC = observer(() => {
  const { chapterExtraPractising, fetchChapterExtraPractising, loading } = useDiscoContent() as {
    // biome-ignore lint/suspicious/noExplicitAny: Player dont have types for its dynamic content structure
    chapterExtraPractising: { flashCards?: any[] };
    fetchChapterExtraPractising: (id: string) => void;
    loading: boolean;
  };
  const { chapterId } = useParams<{ chapterId: string }>();

  useEffect(() => {
    if (chapterId) {
      fetchChapterExtraPractising(chapterId);
    }
  }, [chapterId, fetchChapterExtraPractising]);
  return (
    <div style={{ padding: "20px" }}>
      <h1>Player POC Page</h1>
      <p>This is a proof of concept page to test the Player component on hogeschooltaal.</p>

      {loading && <p>Loading chapter content...</p>}

      {!loading &&
        chapterExtraPractising?.flashCards &&
        chapterExtraPractising?.flashCards.length > 0 && (
          <Player id="poc-player-1" data={{ topics: chapterExtraPractising.flashCards }} />
        )}

      {!loading &&
        (!chapterExtraPractising?.flashCards ||
          chapterExtraPractising?.flashCards.length === 0) && (
          <p>No flashcards available for this chapter.</p>
        )}
    </div>
  );
});
